// extracted by mini-css-extract-plugin
export var box = "_75-1";
export var checked = "_75-2";
export var descriptionSpacer = "_75-9";
export var disabled = "_75-3";
export var icon = "_75-6";
export var input = "_75-0";
export var labelSpacer = "_75-8";
export var medium = "_75-5";
export var small = "_75-4";
export var text = "_75-7";